import { MouseEvent } from 'react'

import { clearStoredAuthCookies } from './_auth'

interface MasqueradeBannerProps {
  masquerading?: boolean
  memberName?: string
  actionLabel?: string
  actionUrl?: string | null
  shouldClearAuthCookies?: boolean
}

export const MasqueradeBanner = ({
  masquerading,
  memberName,
  actionLabel,
  actionUrl,
  shouldClearAuthCookies,
}: MasqueradeBannerProps) => {
  if (!masquerading) return null

  const handleSwitchBack = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    if (!actionUrl) return
    if (shouldClearAuthCookies) {
      clearStoredAuthCookies()
    }
    window.location.href = actionUrl
  }

  return (
    <div className="w-full border-b border-[#c76a10] bg-[#fff2d8] text-[#5c2d0a]">
      <div className="mx-auto flex max-w-[1400px] items-start gap-3 px-6 py-3 text-sm md:text-base">
        <i className="fa-solid fa-user-secret mt-0.5" aria-hidden="true" />
        <p>
          <span className="font-semibold">Masquerade session active.</span> You
          are currently signed in as{' '}
          <span className="font-medium">{memberName || 'this member'}</span>.
          {actionUrl && (
            <>
              {' '}
              <a
                href={actionUrl}
                className="font-semibold underline"
                onClick={handleSwitchBack}
              >
                {actionLabel || 'End masquerade'}
              </a>
              .
            </>
          )}
        </p>
      </div>
    </div>
  )
}

export default MasqueradeBanner
